import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";
import { confirmLeave } from "../lib/unsaved";

// Écrans principaux (barre du bas) : pas de flèche retour
const MAIN = {
  client: ["/", "/trajets", "/reservations", "/compte"],
  driver: ["/", "/chauffeur", "/chauffeur/courses", "/chauffeur/locations", "/compte"],
  admin: ["/", "/admin"],
};
const HOME = { driver: "/chauffeur", admin: "/admin" };

export default function BackButton() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const role = user?.role in MAIN ? user.role : "client";
  const path = pathname.replace(/\/+$/, "") || "/";
  if (MAIN[role].includes(path)) return null;

  const goBack = () => {
    if (!confirmLeave()) return;
    // idx > 0 : une page précédente existe dans l'historique de l'app ; sinon retour à l'accueil
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate(HOME[role] || "/", { replace: true });
  };

  return (
    <button type="button" onClick={goBack} aria-label="Retour" data-testid="header-back-btn"
      className="mr-1 -ml-2 p-2 rounded-xl text-[#1A1F1C] hover:bg-white active:bg-white transition-colors">
      <ArrowLeft size={22} weight="bold" />
    </button>
  );
}
